import cn from 'classnames';
import Link from 'next/link';
import { AnchorArrow } from 'react-scale/components';
import Image from 'next/image';

const Feature = ({ content }) =>
  content.link ? (
    <li className="list-none">
      <Link href={content.link.href} key={content.title}>
        <a>
          <Content content={content} />
        </a>
      </Link>
    </li>
  ) : (
    <li className="list-none">
      <Content content={content} />
    </li>
  );

const Content = ({ content }) => (
  <>
    {content.img && (
      <div
        className={cn('relative mb-5', {
          'overflow-hidden rounded-2xl  mb-10': content.img.borderRadius
        })}
      >
        <Image
          src={content.img.url}
          alt={content.img.alt}
          quality={100}
          width={content.img.width || '40'}
          height={content.img.height || '40'}
          layout={content.img.borderRadius ? 'responsive' : 'intrinsic'}
        />
      </div>
    )}
    {content.overtitle && (
      <h4 className="mb-4 text-overtitle-sm text-gradient">{content.overtitle}</h4>
    )}
    <h1 className="mb-4 text-2xl text-white">{content.title}</h1>
    <p className="text-lg text-gray-400">{content.text}</p>
    {content.list && (
      <ul className="mt-6">
        {content.list.map(item => (
          <li className="mb-2" key={item}>
            <p className="text-base leading-relaxed text-neutral-400">• {item}</p>
          </li>
        ))}
      </ul>
    )}
    {content.checklist && (
      <ul className="mt-6 space-y-4">
        {content.checklist.map(each => {
          // from Builder comes as each.item, but locally we use it as a string
          const item = typeof each === 'string' ? each : each.item;
          return (
            <li key={item}>
              <span className="flex space-x-4">
                <CheckCircle />
                <p className="flex-1 text-base leading-relaxed text-white">{item}</p>
              </span>
            </li>
          );
        })}
      </ul>
    )}
    {content.link && (
      <p className="mt-12">
        <AnchorArrow text={content.link.text} href={content.link.href} />
      </p>
    )}
  </>
);

const CheckCircle = () => (
  <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="12.3013" r="12" fill="#D1AAD7" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.3789 6.8376C17.7601 6.52701 18.3248 6.49878 18.7201 6.82348C19.1718 7.20466 19.2283 7.86819 18.833 8.31995L11.3789 17.2705C11.2518 17.4258 11.1106 17.567 10.9412 17.68C9.96712 18.3294 8.65418 18.0611 8.00477 17.087L5.0683 12.6823C4.74359 12.2023 4.88477 11.5388 5.36477 11.2141C5.73183 10.9741 6.19771 10.9882 6.53653 11.2141L9.6283 13.2611L17.3648 6.82348L17.3789 6.8376Z"
      fill="black"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 24.3013C18.6274 24.3013 24 18.9287 24 12.3013C24 5.67385 18.6274 0.30127 12 0.30127C5.37258 0.30127 0 5.67385 0 12.3013C0 18.9287 5.37258 24.3013 12 24.3013ZM12 24.3013C5.37882 24.3013 0 18.9224 0 12.3013C0 5.68009 5.37882 0.30127 12 0.30127C18.6212 0.30127 24 5.68009 24 12.3013C24 18.9224 18.6212 24.3013 12 24.3013Z"
      fill="#E5E5E5"
    />
  </svg>
);

export default Feature;
